import { Component, computed, Input, Signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { iUser } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    RouterLink
  ]
})
export class DesktopHeaderComponent {

  @Input() title: string = 'Greenland Travel Platform';
  @Input() backPath: string = '';

  public user: Signal<iUser> = computed(() => this.authService.user());

  constructor(
    public authService: AuthenticationService
  ) {}

}
